export default {
  active: false,
  appliedFilters: {
    numericFilters: [],
  },
};
